export { default } from './TextareaAutosize';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TextareaAutosize/index.js
// module id = 132
// module chunks = 0